import React, { useEffect, useState } from "react"
import { private_server } from "../../config"
import { isFormValid, onGetErrorMessage, onGetSelectedFormData, onInitForm, onSetErrorsToForm, updateAuthorizationHeader } from "../../shared/utility"
import queryString from 'query-string'
import { generic_errors } from "../../texts/eng/genericErrors"
import catalogs from "../../texts/eng/catalogs"

const useContactView = ({ language, history, is_auth, content }) => {

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(null)

    const [total, setTotal] = useState(0)
    const [search, setSearch] = useState(null)
    const [filterValue, setFilterValue] = useState(-1)
    const [tableFilter, setTableFilter] = useState({ limit: 10, offset: 0, order_by: 'id_contact_request', order: 1 })
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    //DATA
    const [contacts, setContacts] = useState([])
    const [contact, setContact] = useState(null)
    const [contactID, setContactID] = useState(null)
    const [add_modal, setAddModal] = useState(false)
    const [edit_modal, setEditModal] = useState(false)

    useEffect(() => {
        if (is_auth)
            actions.onInitModule()
    }, [is_auth])

    useEffect(() => {
        if (is_auth)
            actions.onFilterContacts()
    }, [is_auth, tableFilter])

    useEffect(() => {
        if (is_auth)
            actions.onResetTableFilter()
    }, [is_auth, filterValue])

    const actions = {
        onInitModule: () => {
            let _form = JSON.parse(JSON.stringify(formData))
            _form = onInitForm(_form, null, content.form)
            setForm(_form)
        },
        onResetTableFilter: () => setTableFilter({ limit: 10, offset: 0, order_by: 'id_contact_request', order: 1 }),
        onCloseError: () => setError(null),
        onUpdateTableFilter: (data) => setTableFilter(data),
        onUpdateFilterValue: (id) => setFilterValue(id),
        onOpenAddModal: () => {
            let _form = JSON.parse(JSON.stringify(formData))
            _form = onInitForm(_form, null, content.form)
            setForm(_form)
            setAddModal(true)
        },
        onCloseAddModal: () => setAddModal(false),
        onChange: (data) => {
            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data }
            if (error) setError(null)
            setForm(temp)
        },
        onSearchContact: async (data) => {
            let temp = { ...form }
            temp.search = { ...data }
            if (error) setError(null)
            setForm(temp)
            setSearch(data.value)
        },
        onFilterContacts: async () => {
            try {
                setSending(true)
                let filter = { AND: [] }
                if (filterValue > -1) filter.AND.push({ field: "contacted", operator: "=", value: filterValue })
                if (search && search.length > 0) filter.AND.push({ field: "name", operator: "LIKE", value: `%%${search}%%` })
                let _filter = encodeURIComponent(JSON.stringify(filter))
                let params = filter.AND.length > 0 ? `?${queryString.stringify(tableFilter)}&filter=${_filter}` : `?${queryString.stringify(tableFilter)}`
                const _contacts = await private_server.get(`contactrequest/all${params}`)
                setContacts([..._contacts.data.data.contact_requests])
                setTotal(_contacts.data.data.count)
            } catch (error) {
                setError(onGetErrorMessage(error))
            }
            setSending(false)
        },
        onSelectContact: (_contact) => {
            setContact(_contact)
            setContactID(_contact.id_contact_request)
            const _form = onInitForm(form, _contact, content.form)
            setForm(_form)
            setEditModal(true)
        },
        onCloseEditModal: () => setEditModal(false),
        onAddContact: async () => {
            try {
                setSending(true)

                const errors = isFormValid(form)

                // Error handler
                if (errors && errors.length) {
                    const _form = onSetErrorsToForm(form, errors)
                    setForm(_form)
                    setError(generic_errors[language].INCOMPLETE_FORM)
                    setSending(false)
                    return
                }

                const data2send = onGetSelectedFormData(form, contacts)

                await private_server.post(`contactrequest`, data2send)
                let params = `?${queryString.stringify(tableFilter)}`
                const _contacts = await private_server.get(`/contactrequest/all${params}`)
                setContacts(_contacts.data.data.contact_requests)
                setTotal(_contacts.data.data.count)
                setFilterValue(-1)
                setTableFilter({ limit: 10, offset: 0, order_by: 'id_contact_request', order: 1 })

                setError(null)
                setAddModal(false)
            } catch (error) {
                setError(onGetErrorMessage(error))
            }
            setSending(false)
        },
        onUpdateContact: async () => {
            try {
                setSending(true)

                const errors = isFormValid(form)

                // Error handler
                if (errors && errors.length) {
                    const _form = onSetErrorsToForm(form, errors)
                    setForm(_form)
                    setError(generic_errors[language].INCOMPLETE_FORM)
                    setSending(false)
                    return
                }

                const data2send = onGetSelectedFormData(form, contacts)

                await private_server.patch(`contactrequest/${contactID}`, data2send)
                let params = `?${queryString.stringify(tableFilter)}`
                const _contacts = await private_server.get(`/contactrequest/all${params}`)
                setEditModal(false)
                setContacts(_contacts.data.data.contact_requests)
                setTotal(_contacts.data.data.count)
                setFilterValue(-1)
                setTableFilter({ limit: 10, offset: 0, order_by: 'id_contact_request', order: 1 })
                setError(null)
                setSending(false)
            } catch (error) {
                setError(onGetErrorMessage(error))
            }
            setSending(false)
        },
    }

    const system = { loading, sending, error }
    const view_data = { total, filterValue, contacts, form, tableFilter, add_modal, edit_modal }

    return { system, view_data, actions }
}

export default useContactView

const formData = {
    search: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'search',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
    name: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'name',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
    email: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'email',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'email'
        }
    },
    country_code: {
        value: '+49',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: true,
        options: [...catalogs.country_codes],
        config: {
            id: 'country_code',
            type: 'select',
            fullWidth: true,
        },
        rules: { type: 'select' }
    },
    phone: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'phone',
            type: 'number',
            fullWidth: true,
        },
        rules: {
            type: 'phone_number'
        }
    },
    date: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'date',
            type: 'date',
            fullWidth: true,
        },
        rules: {
            type: 'date'
        }
    },
    contacted: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'contacted'
        }
    },
    contacted_at: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'contacted_at',
            type: 'date',
            fullWidth: true,
        },
        rules: {
            type: 'date'
        }
    },
    message: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'message',
            type: 'text',
            fullWidth: true,
            multiline: true,
            rows: 4
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
}